{
  "name": "globo-dog",
  "version": "1.5.6",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "extract-translations": "ngx-translate-extract --input ./src --output ./src/assets/i18n/en.json --output ./src/assets/i18n/hu.json --output ./src/assets/i18n/it.json --output ./src/assets/i18n/de.json --key-as-default-value --format json --marker _",
    "extract-translations-clean": "ngx-translate-extract --input ./src --output ./src/assets/i18n/en.json --output ./src/assets/i18n/hu.json --output ./src/assets/i18n/it.json --output ./src/assets/i18n/de.json --key-as-default-value --format json --marker _ --clean"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.0.0",
    "@angular/cdk": "^18.0.3",
    "@angular/common": "^18.0.0",
    "@angular/compiler": "^18.0.0",
    "@angular/core": "^18.0.0",
    "@angular/forms": "^18.0.0",
    "@angular/material": "^18.0.3",
    "@angular/material-moment-adapter": "^18.0.4",
    "@angular/platform-browser": "^18.0.0",
    "@angular/platform-browser-dynamic": "^18.0.0",
    "@angular/router": "^18.0.0",
    "@capacitor/android": "^8.0.0",
    "@capacitor/app": "^8.0.0",
    "@capacitor/browser": "^8.0.3",
    "@capacitor/core": "^8.0.0",
    "@capacitor/ios": "^8.0.0",
    "@capacitor/push-notifications": "^8.0.0",
    "@capawesome/capacitor-badge": "^8.0.3",
    "@capgo/capacitor-age-range": "^8.1.9",
    "@colsen1991/ngx-translate-extract-marker": "^2.0.8",
    "@googlemaps/js-api-loader": "^1.16.8",
    "@googlemaps/markerclusterer": "^2.5.3",
    "@messageformat/core": "^3.3.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@types/gettext-parser": "^4.0.4",
    "@types/node": "^22.7.4",
    "@types/readable-stream": "^4.0.15",
    "install": "^0.13.0",
    "ngx-image-cropper": "^9.1.7",
    "ngx-mat-timepicker": "^18.0.1",
    "ngx-quill": "^26.0.10",
    "ngx-translate-messageformat-compiler": "^7.0.0",
    "quill-image-resizor": "^3.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "util": "^0.12.5",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.0.3",
    "@angular/cli": "^18.0.3",
    "@angular/compiler-cli": "^18.0.0",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.0.0",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.10",
    "@vendure/ngx-translate-extract": "^9.2.1",
    "angular-eslint": "18.0.1",
    "eslint": "^9.3.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.3.2",
    "prettier-eslint": "^16.3.0",
    "typescript": "~5.4.2",
    "typescript-eslint": "8.0.0-alpha.20",
    "vite-plugin-node-polyfills": "^0.22.0"
  }
}
